import APIService from "./APIService";

export default {
  index() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(`/governanca/responsaveis-temas`)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  addResponsavelTemas(postData) {
    return APIService.apiCall().post(
      `/governanca/responsaveis-temas/responsavel`,
      postData
    );
  },
  deleteResponsavelTema(id) {
    return APIService.apiCall().delete(`/governanca/responsaveis-temas/${id}`);
  },
};
